<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-上传设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--邮箱设置-->
      <div class="common-form">邮箱设置</div>
      <div>
        <el-form-item label="SMTP服务器"><el-input v-model="form.server"></el-input></el-form-item>
        <el-form-item label="SMTP服务器端口"><el-input v-model="form.domain"></el-input></el-form-item>
        <el-form-item label="SMTP用户名"><el-input v-model="form.userName"></el-input></el-form-item>
        <el-form-item label="SMTP授权码"><el-input v-model="form.emailCode"></el-input></el-form-item>
        <el-form-item label="SMTP邮箱"><el-input v-model="form.email"></el-input></el-form-item>
        <el-form-item label="显示名称"><el-input v-model="form.modelName"></el-input></el-form-item>
        <el-form-item label="邮箱模板"><el-input v-model="form.modelEmail"></el-input></el-form-item>
      </div>
      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        server: '',
        domain: '',
        userName: '',
        emailCode: '',
        email: '',
        modelName: '',
        modelEmail: '',
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.emailDetail({}, true)
        .then(data => {
          let vars = data.data.vars.values.emailModel;
          self.form = vars;
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editEmail(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，邮箱设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    //监听单选按钮
    getRadio(val) {}
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/email/index.vue